import React from 'react';
import CountUp from 'react-countup';

// image
import Ab1 from '../../images/about.webp'
import Abd1 from '../../images/doctors/1.jpg'
import Abd2 from '../../images/doctors/2.jpg'
import Abd3 from '../../images/doctors/3.jpg'
import Abd4 from '../../images/doctors/4.jpg'
import sine from '../../images/signeture.png'

const About = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="about_left">
                            <div className="image">
                                <img src={Ab1} alt="Pharmacy Freedom Fund Office" />
                                <span className="round-on"></span>
                                <span className="round-two"></span>
                                <div className="award">
                                    <div className="icon">
                                        <i className="flaticon-cup"></i>
                                    </div>
                                    <div className="text">
                                        <h2><CountUp end={10} enableScrollSpy />+</h2>
                                        <p>Years of Excellence</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="content">
                            <h2>About Pharmacy Freedom Fund</h2>
                            <h3>Transforming Pharmacies, Maximizing Returns</h3>
                            <p>Pharmacy Freedom Fund is a specialized investment firm focused on acquiring and optimizing independent pharmacies. Our strategy encompasses identifying undervalued pharmacies, implementing operational improvements, and leveraging technology to enhance patient care and drive profitability.</p>
                            <p>With a team of experienced healthcare and investment professionals, we aim to generate substantial returns for our investors while contributing to the advancement of community healthcare. Our approach combines financial acumen with deep industry knowledge to create value in the evolving pharmacy landscape.</p>
                            <div className="ceo">
                                <div>
                                    <h4>Amr Hillal</h4>
                                    <span>General Partner</span>
                                </div>
                                <div>
                                    <div
                                        style={{
                                            fontFamily: "'Great Vibes', cursive",
                                            fontSize: "48px",
                                            color: "#2c3e50",
                                            textAlign: "center",
                                            padding: "10px",
                                        }}
                                    >
                                        Amr Hillal
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;

